<h1 mat-dialog-title>Step to get a Youtube video link</h1>
<div mat-dialog-content>
  <ul>
    <li>Open Youtube & Select your video</li>
    <li>Click a share button & Copy your selected video link</li>
    <li>Paste your Youtube video link</li>
  </ul>
</div>
<div mat-dialog-actions class="f-right">
  <button mat-button mat-dialog-close cdkFocusInitial>Close</button>
</div>
